// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"P4-z"};